import { useMemo } from "react";

import { useReferentialUserStates } from "@/entities/referential/referential-user-states";

export const useUserStatesFilter = () => {
  const { userStates } = useReferentialUserStates();

  const filters = useMemo(
    () =>
      userStates.map((state) => ({
        text: state.name,
        value: state.value,
      })),
    [userStates]
  );

  return {
    filterMode: "tree",
    filters,
  };
};
